export default __webpack_public_path__ + "static/media/close-outline.d4aee1ca.svg";